// Slovník lidských názvů časových řad z /api/ts_info (viz doc/plans/to-fill-human-labels.md).
// Načte se 1× (dump všech spec tabulek) a cachuje jako elements.
// Klíč mapy = (typ, ts_id) — ts_id se napříč spec tabulkami kříží.
import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { typFromEndpoint } from '../utils/tsTyp'

const keyOf = (typ, id) => `${typ}|${id}`

export function useTsInfo() {
  const { data = [] } = useQuery({
    queryKey: ['tsInfo'],
    queryFn: () => api.get('/ts_info?dump=1&cache=[1440]'),
    staleTime: Infinity,
  })

  const map = Object.fromEntries(data.map((r) => [keyOf(r.typ, r.id), r]))

  // lookup z to_fill položky (má .endpoint + .params.ts_id)
  const infoFor = (item) =>
    map[keyOf(typFromEndpoint(item?.endpoint), item?.params?.ts_id)]

  return { infoFor }
}
